import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const GTMPageView = (): null => {
  const location = useLocation()

  useEffect(() => {
    window.dataLayer?.push({
      event: 'virtualPageView',
      virtualPagePath: location.pathname
    })
  }, [location.pathname])

  return null
}
